import { type RefObject, useEffect } from 'react';

const isScrollable = (element: HTMLElement): boolean => {
  const { overflowY } = getComputedStyle(element);
  return (
    (overflowY === 'auto' || overflowY === 'scroll') &&
    element.scrollHeight > element.clientHeight
  );
};

/**
 * Forwards wheel scrolling anywhere on the page onto `scrollRef`
 */
export const useForwardWheelToScrollContainer = (
  scrollRef: RefObject<HTMLElement | null>,
): void => {
  useEffect(() => {
    const onWheel = (event: WheelEvent) => {
      if (event.ctrlKey) {
        return;
      }

      const scrollElement = scrollRef.current;
      const target = event.target as HTMLElement | null;
      if (!scrollElement || !target || scrollElement.contains(target)) {
        return;
      }

      let node: HTMLElement | null = target;
      while (node && node !== document.body) {
        if (isScrollable(node)) {
          return;
        }
        node = node.parentElement;
      }

      event.preventDefault();
      scrollElement.scrollTop += event.deltaY;
    };

    window.addEventListener('wheel', onWheel, { passive: false });
    return () => window.removeEventListener('wheel', onWheel);
  }, [scrollRef]);
};
